import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import GenericResult from './generic-result-model'
import {
  CreateGenericResultAsync,
  DeleteGenericResultAsync,
  LoadGenericResultsAsync,
} from './genericResult-thunk'
const initialState: genericResultSliceState = {
  genericResult: [],
  selected_genericResult: '',
  is_loading_genericResult: false,
  is_creating_genericResult: false,
  is_deleting_genericResult: false,
}
export interface genericResultSliceState {
  genericResult: GenericResult[]
  selected_genericResult?: string
  is_loading_genericResult: boolean
  is_creating_genericResult: boolean
  is_deleting_genericResult: boolean
}
export const genericResultSlice = createSlice({
  name: 'genericResult',
  initialState,
  reducers: {
    setSelectedgenericResult: (state, action) => {
      state.selected_genericResult = action.payload
    },
    clearStategenericResult: (state) => {
      state.genericResult = []
      state.is_loading_genericResult = false
      state.is_creating_genericResult = false
      state.is_deleting_genericResult = false
    },
    mergegenericResult: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_genericResult = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.genericResult = merge(state.genericResult, payload) as any
        }
      }
    },

    add_genericResult: (state, action) => {
      if (action.payload) {
        state.genericResult = [...state.genericResult, action.payload]
      }
    },
    set_genericResult: (state, action) => {
      let { key, value, id } = action.payload
      state.genericResult = state.genericResult.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadGenericResultsAsync.pending, (state) => {
      state.is_loading_genericResult = true
    })
    builder.addCase(LoadGenericResultsAsync.fulfilled, (state, action) => {
      state.is_loading_genericResult = false
      if (action.payload) {
        state.genericResult = action.payload
      }
    })
    builder.addCase(LoadGenericResultsAsync.rejected, (state) => {
      state.is_loading_genericResult = false
    })
    builder.addCase(CreateGenericResultAsync.pending, (state) => {
      state.is_creating_genericResult = true
    })
    builder.addCase(CreateGenericResultAsync.fulfilled, (state) => {
      state.is_creating_genericResult = false
    })
    builder.addCase(CreateGenericResultAsync.rejected, (state) => {
      state.is_creating_genericResult = false
    })
    builder.addCase(DeleteGenericResultAsync.pending, (state) => {
      state.is_deleting_genericResult = true
    })
    builder.addCase(DeleteGenericResultAsync.fulfilled, (state, action) => {
      state.is_deleting_genericResult = false
      if (state.genericResult) {
        state.genericResult = state.genericResult.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteGenericResultAsync.rejected, (state) => {
      state.is_deleting_genericResult = false
    })

    builder.addCase(autoThunks.check_account.pending, (state) => {
      state.is_loading_genericResult = true
    })
    builder.addCase(autoThunks.check_account.fulfilled, (state, action) => {
      state.is_loading_genericResult = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.check_account.rejected, (state) => {
      state.is_loading_genericResult = false
    })

    builder.addCase(autoThunks.connect_mobile_login.pending, (state) => {
      state.is_loading_genericResult = true
    })
    builder.addCase(
      autoThunks.connect_mobile_login.fulfilled,
      (state, action) => {
        state.is_loading_genericResult = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.connect_mobile_login.rejected, (state) => {
      state.is_loading_genericResult = false
    })

    builder.addCase(autoThunks.update_cache_media_urls.pending, (state) => {
      state.is_loading_genericResult = true
    })
    builder.addCase(
      autoThunks.update_cache_media_urls.fulfilled,
      (state, action) => {
        state.is_loading_genericResult = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.update_cache_media_urls.rejected, (state) => {
      state.is_loading_genericResult = false
    })

    builder.addCase(autoThunks.run_metric_jobs.pending, (state) => {
      state.is_loading_genericResult = true
    })
    builder.addCase(autoThunks.run_metric_jobs.fulfilled, (state, action) => {
      state.is_loading_genericResult = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.run_metric_jobs.rejected, (state) => {
      state.is_loading_genericResult = false
    })

    builder.addCase(autoThunks.reset_cursors.pending, (state) => {
      state.is_loading_genericResult = true
    })
    builder.addCase(autoThunks.reset_cursors.fulfilled, (state, action) => {
      state.is_loading_genericResult = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.reset_cursors.rejected, (state) => {
      state.is_loading_genericResult = false
    })

    builder.addCase(autoThunks.store_start_up_cache.pending, (state) => {
      state.is_loading_genericResult = true
    })
    builder.addCase(
      autoThunks.store_start_up_cache.fulfilled,
      (state, action) => {
        state.is_loading_genericResult = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.store_start_up_cache.rejected, (state) => {
      state.is_loading_genericResult = false
    })
  },
})

function handleResult(action: any, state: genericResultSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_genericResult = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.genericResult = merge(state.genericResult, payload) as any
    }
  }
}

export const {
  clearStategenericResult,
  setSelectedgenericResult,
  set_genericResult,
  mergegenericResult,
  add_genericResult,
} = genericResultSlice.actions

export const get_genericResult =
  (id?: string) =>
  (state: {
    genericResult: {
      genericResult: GenericResult[]
    }
  }): GenericResult | null => {
    let temp = state?.genericResult?.genericResult?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.genericResult?.genericResult[0] || null
  }
export const get_selected_genericResult = (state: {
  genericResult: genericResultSliceState
}): GenericResult | null => {
  let id = state?.genericResult?.selected_genericResult
  let temp = state?.genericResult?.genericResult?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_genericResult = (state: {
  genericResult: {
    genericResult: GenericResult[]
  }
}): GenericResult[] => {
  let temp = state?.genericResult?.genericResult
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_genericResult_busy = (state: {
  genericResult: genericResultSliceState
}) => {
  return (
    state?.genericResult.is_deleting_genericResult ||
    state?.genericResult.is_loading_genericResult ||
    state?.genericResult.is_creating_genericResult
  )
}
export const is_deleting_genericResult_busy = (state: {
  genericResult: genericResultSliceState
}) => {
  return state?.genericResult.is_deleting_genericResult
}
export const is_loading_genericResult_busy = (state: {
  genericResult: genericResultSliceState
}) => {
  return state?.genericResult.is_loading_genericResult
}
export const is_creating_genericResult_busy = (state: {
  genericResult: genericResultSliceState
}) => {
  return state?.genericResult.is_creating_genericResult
}

export default genericResultSlice.reducer
